import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map, shareReplay, withLatestFrom } from 'rxjs/operators';
import { News, NewsPage } from '../model';
import { NewsActions } from '../store/actions';
import { StateWithNews } from '../store/news-state';
import { NewsSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class NewsService {
  constructor(private store: Store<StateWithNews>) {}

  getNews(count: string): Observable<News[] | undefined> {
    return this.store.pipe(
      select(NewsSelectors.getNews(count)),
      withLatestFrom(this.store.pipe(select(NewsSelectors.getDetailedPageState(count)))),
      filter(([_news, detailedPageState]) => {
        if (this.needsToLoad(detailedPageState)) {
          this.loadNews(count);
          return false;
        }

        return detailedPageState.success;
      }),
      map(([news, _detailedPageState]) => news),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }

  private needsToLoad(newsListState: StateUtils.LoaderState<NewsPage>) {
    if (!!newsListState.value?.lastUpdateTime) {
      const lastUpdateTime = new Date(newsListState.value?.lastUpdateTime);
      const currentTime = new Date();
      currentTime.setMinutes(currentTime.getMinutes() - 10);
      const timeTenMinutesAgo = currentTime;

      if (newsListState.success && lastUpdateTime < timeTenMinutesAgo) {
        return true;
      }
    }

    return !newsListState.success && !newsListState.error && !newsListState.loading;
  }

  private loadNews(count: string): void {
    this.store.dispatch(new NewsActions.LoadNews(count));
  }
}
